<div mat-dialog-title class="label">{{data.label}}</div>
<div mat-dialog-content>
    <div class="grid">
        <div class="column-comment">
            <mat-form-field>
                <mat-label></mat-label>
                <textarea [readonly]="data.readOnly" matInput [attr.maxlength]="data.maxLength" placeholder="Agregue comentarios..." rows="5" #comments cdkFocusInitial>{{data.comments}}</textarea>
            </mat-form-field>
        </div>
        <div class="column-ready">
            <button mat-button [mat-dialog-close]="comments.value" class="ready">LISTO</button>
        </div>
    </div>
</div>
